/* eslint-disable */
const defaultState = [];

export default function (state = defaultState, action) {
  switch (action.type) {

    case 'GET_COUNTRIES_SUCCESS':
      return action.data;

    default:
      return state;
  }
}
